import { SortDirection } from '../components'

interface ActiveSortOptionProps<ColumnKeyType> {
  columnKey: ColumnKeyType
  sortOrder: SortDirection
  activeSortKey?: ColumnKeyType
}

export function getActiveSortOption<ColumnKeyType>({
  columnKey,
  sortOrder,
  activeSortKey,
}: ActiveSortOptionProps<ColumnKeyType>) {
  if (columnKey === activeSortKey) {
    return sortOrder
  }

  return undefined
}
